'use strict';

var projectServiceTypes = require('@customink/project-service-types');
var merge = require('lodash/merge');

const DEFAULT_HOSTNAME = 'https://project-service.lambda-staging.customink.com';
const defaultConfiguration = {
    hostName: DEFAULT_HOSTNAME,
};
class Configuration {
    constructor(configuration) {
        this._configuration = Object.assign(Object.assign({}, defaultConfiguration), configuration);
    }
    get baseUrl() {
        return `${this.hostName}/projects`;
    }
    get hostName() {
        return this._configuration.hostName;
    }
    getProjectItemsUrl(projectId) {
        return `${this.hostName}/projects/${projectId}/items`;
    }
}

const httpCorsOptions = {
    credentials: 'include',
    mode: 'cors',
};
const httpGetOptions = Object.assign(Object.assign({}, httpCorsOptions), { method: 'GET' });
const httpPostOptions = Object.assign(Object.assign({}, httpCorsOptions), { headers: { 'Content-Type': 'application/json' }, method: 'POST' });
Object.assign(Object.assign({}, httpPostOptions), { method: 'PUT' });
const checkResponseOkay = (response) => {
    if (response.ok) {
        return;
    }
    throw response.statusText;
};

class ProjectClient {
    constructor(configuration, project = {}) {
        this.items = {};
        this.config = new Configuration(configuration);
        this.project = project;
    }
    async fetch(id = 'current') {
        const url = `${this.config.baseUrl}/${id}`;
        try {
            const response = await fetch(url, httpGetOptions);
            checkResponseOkay(response);
            this.project = await response.json();
        }
        catch (_a) {
            this.project = {};
        }
        return this.project;
    }
    async save() {
        let url = this.config.baseUrl;
        delete this.project.version;
        const versionedProjectData = Object.assign({ version: projectServiceTypes.CURRENT_PROJECT_VERSION }, this.project);
        const requestOptions = Object.assign(Object.assign({}, httpPostOptions), { body: JSON.stringify(versionedProjectData) });
        if (this.project.id) {
            url += `/${this.project.id}`;
            requestOptions.method = 'PUT';
        }
        try {
            const response = await fetch(url, requestOptions);
            checkResponseOkay(response);
            this.project = await response.json();
        }
        catch (err) {
            this.project = {};
        }
        return this.project;
    }
    async fetchItem(itemId) {
        const projectId = this.project.id;
        if (projectId === 'current') {
            return this.items;
        }
        const url = `${this.config.baseUrl}/${projectId}/items/${itemId}`;
        const requestOptions = {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
        };
        try {
            const response = await fetch(url, requestOptions);
            checkResponseOkay(response);
            this.items = await response.json();
        }
        catch (_a) {
            this.items = {};
        }
        return this.items;
    }
    async fetchItems() {
        const projectId = this.project.id;
        const url = `${this.config.baseUrl}/${projectId}/items`;
        const requestOptions = {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
        };
        try {
            const response = await fetch(url, requestOptions);
            checkResponseOkay(response);
            this.items = await response.json();
        }
        catch (_a) {
            this.items = {};
        }
        return this.items;
    }
    async addItems(items) {
        if (!this.project.id) {
            this.project.items = items;
            this.save();
        }
        else {
            const url = `${this.config.baseUrl}/${this.project.id}/items`;
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(items),
                credentials: 'include',
                mode: 'cors',
            };
            try {
                const response = await fetch(url, requestOptions);
                checkResponseOkay(response);
                this.items = await response.json();
            }
            catch (err) {
                this.items = {};
            }
        }
        return this.items;
    }
    async updateItems(items) {
        const url = `${this.config.baseUrl}/${this.project.id}/items`;
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(items),
            credentials: 'include',
            mode: 'cors',
        };
        try {
            const response = await fetch(url, requestOptions);
            checkResponseOkay(response);
            this.items = await response.json();
        }
        catch (err) {
            this.items = {};
        }
        return this.items;
    }
    async convert() {
        const url = `${this.config.baseUrl}/${this.project.id}/convert`;
        const requestOptions = {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
        };
        try {
            const response = await fetch(url, requestOptions);
            checkResponseOkay(response);
            this.project = await response.json();
        }
        catch (_a) {
            this.project = {};
        }
        return this.project;
    }
    async saveProject(data) {
        this.project = Object.assign(Object.assign({}, this.project), data);
        return this.save();
    }
    async updateProjectConfiguration(data) {
        const project = await this.getCurrentProject();
        merge(project, { configuration: data });
        return this.updateProject(project.id, project);
    }
    async updateEstimatedQuantity(estimatedQuantity) {
        const project = await this.getCurrentProject();
        merge(project, {
            configuration: { estimatedTotalQuantity: estimatedQuantity },
        });
        return this.updateProject(project.id, project);
    }
    async getProjectConfiguration() {
        const response = await this.getCurrentProject();
        return response.configuration ? response.configuration : {};
    }
    async getCurrentProject() {
        return this.fetch();
    }
    async getProject(id) {
        return this.fetch(id);
    }
    async createProject(data) {
        this.project = Object.assign(Object.assign({}, this.project), data);
        return this.save();
    }
    async updateProject(id, data) {
        this.project = Object.assign(Object.assign(Object.assign({}, this.project), { id }), data);
        return this.save();
    }
}

exports.ProjectClient = ProjectClient;
//# sourceMappingURL=index.js.map
